var downloadReportModalInterface = require('../layout/components/downloadReportModalInterface');

function hasDownloadableData(report) {
  if (!report) return false;
  if (report.type && report.type !== 'Custom Export') return true;
  if (report.hasChildrenDatasets) return true;
  return (Array.isArray(report.out_Contains) ? report.out_Contains : []).some(function (edge) {
    return edge && edge.in;
  });
}

function open(report) {
  if (!report || !report['@rid']) return;
  return downloadReportModalInterface.editDialogue({
    modalTitle: 'Download ' + (report.name || 'Report'),
    reportType: report.type || 'Custom Export',
    reportRid: report['@rid'],
    reportRecord: report,
    sourceKind: 'reportRecord'
  });
}

module.exports = {
  hasDownloadableData: hasDownloadableData,
  open: open
};
